import { mergeAttributes } from "@tiptap/core";
import BaseHeading from "@tiptap/extension-heading";

type Levels = 1 | 2 | 3;
const headingClasses = (level: number) => {
  switch (level) {
    case 1:
      return "font-medium text-3xl mb-3 mt-4";
    case 2:
      return "font-medium text-2xl mb-3 mt-4";
    case 3:
      return "font-medium text-xl mb-3 mt-4";
    case 4:
      return "font-medium text-lg mb-3 mt-4";
    case 5:
      return "font-medium text-base mb-3 mt-4";
    case 6:
      return "font-medium text-sm mb-3 mt-4";
    default:
      return "";
  }
};

export const Heading = BaseHeading.configure({ levels: [1, 2, 3] }).extend({
  renderHTML({ node, HTMLAttributes }) {
    const hasLevel = this.options.levels.includes(node.attrs.level);
    const level: Levels = hasLevel ? node.attrs.level : this.options.levels[0];

    return [
      `h${level}`,
      mergeAttributes(this.options.HTMLAttributes, HTMLAttributes, {
        class: `${headingClasses(level)}`,
      }),
      0,
    ];
  },
});
